<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



document.addEventListener('DOMContentLoaded', () => {
    const customBtn = document.querySelector('.halo-sidebar-close');

    customBtn.addEventListener('click', function() {
        // Body se sari classes remove karne ke liye
        document.body.className = document.body.className
            .split(' ') // Classes ko array me convert karna
            .filter(cls => !cls.startsWith('menu-open')) // Sirf 'menu-open' se related classes hatao
            .join(' '); // Dobara string me convert karna
    });
});




  

  